/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Retry_ButtonInputs */



/**
* | output |
* | --- |
* | "Retry Connection" |
*
* @param {Offline_Retry_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_retry_button = /** @type {((inputs?: Offline_Retry_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Retry_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réessayer la Connexion")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbindung erneut versuchen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riprova la connessione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Повторить попытку подключения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reintentar la conexión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重试连接")
	if (locale === "ja") return /** @type {LocalizedString} */ ("接続を再試行する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कनेक्शन पुनः प्रयास करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tentar novamente a conexão")
	return /** @type {LocalizedString} */ ("Retry Connection")
});